import { useQuery } from '@tanstack/react-query'

import { getProductById } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  productId?: ParameterID
  enabled?: boolean
}

export function useQueryGetProductById({ productId, enabled }: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetProductById', Number(productId)],
    queryFn: async () => await getProductById(productId ?? ''),
    refetchOnWindowFocus: false,
    enabled: enabled ?? isValidParameterID(productId),
  })
}
